import { Box, Link, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  children: React.ReactNode
  label: string
  link?: string
}

const TooltipContent = ({ label, link }: { label: string; link?: string }) => {
  return (
    <Box>
      <Text.Normal size="200">{label}</Text.Normal>
      {link && (
        <Link.Href type="inverse" target="_blank" href={link}>
          {i18n.t('common.more_information')}
        </Link.Href>
      )}
    </Box>
  )
}

export const CustomTooltip = ({ children, label, link }: Props) => {
  const [openTooltip, toggleTooltip] = useToggle(false)
  const offset = '-10 0'

  return (
    <Tooltip.Dialog
      backgroundColor="grey1000"
      open={openTooltip}
      toggle={toggleTooltip}
      attachment="bottom center"
      label={<TooltipContent label={label} link={link} />}
      offset={offset}
      size="normal"
      paddingX="s8"
      paddingY="s8"
      textAlign="left"
    >
      {children}
    </Tooltip.Dialog>
  )
}
